import { useServices } from "@/services-context";
import { B2bPageDesktop } from "./b2b-page-desktop";
import { LocationHook, RouteHook, useLocation, useRoute } from "preact-iso";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { pageSuspense, useSuspenseLoader } from "@/helpers/suspense";
import { Services } from "@/services/services";
import { PageTags } from "@/elements-react/document-elements/page-tags.tsx";
import { Url } from "@/helpers/url.ts";
import { SeoMarkupDataset } from "@/services/seo-markup.ts";
import { defaultLang } from "@/constants/languages.ts";
import {B2bPageMobile} from "@/pages-react/b2b-page/b2b-page-mobile.tsx";

const fetchPageData = async (params: { services: Services; location: LocationHook; route: RouteHook }) => {
    const { services, location, route } = params;

    const registryUrl = Url.normalizeRoute(route.path);
    const alternates = await services.routes.resolveAlternates(registryUrl);

    await services.initialize.prepare({
        location: location,
        route: route,
    });

    const canonical = !registryUrl ? `/${defaultLang}/b2b-platform` : registryUrl;

    return {
        type: "static",
        canonical: canonical,
        alternates: alternates,
    };
};

const getPageComponent = (layoutType: LayoutTypes) => {
    switch (layoutType) {
        case LayoutTypes.TYPE_DESKTOP:
            return B2bPageDesktop;
        case LayoutTypes.TYPE_MOBILE:
            return B2bPageMobile;
    }
};

export const B2bPage = pageSuspense(() => {
    const route = useRoute();
    const location = useLocation();
    const services = useServices();
    const { layoutType } = useLayoutType();

    const seoMarkupDataset = useSuspenseLoader({
        key: "b2b-route",
        loader: () =>
            fetchPageData({
                services: services,
                location: location,
                route: route,
            }),
    }) as SeoMarkupDataset;

    const PageComponent = getPageComponent(layoutType);

    return (
        <div style={{ display: "contents" }}>
            <PageComponent />
            <PageTags seo={seoMarkupDataset} />
        </div>
    );
});
